import React from 'react';

import {
  Box,
  Button,
  Paper,
  Typography,
} from '@mui/material';

import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';


const OrganizationSetupWidget = ({
  organization,
  onOpen,
}) => {
  return (
    <Paper
      sx={{
        p: {
          xs: 2.5,
          md: 3,
        },

        width: '100%',

        borderRadius: '14px',

        border:
          '1px solid rgba(255, 193, 7, 0.35)',

        background:
          'linear-gradient(135deg, rgba(255,193,7,0.13), rgba(255,255,255,0.03))',

        display: 'flex',

        flexDirection: {
          xs: 'column',
          md: 'row',
        },

        alignItems: {
          xs: 'flex-start',
          md: 'center',
        },

        justifyContent:
          'space-between',

        gap: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,

            flexShrink: 0,

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            borderRadius: '12px',

            backgroundColor:
              'rgba(255, 193, 7, 0.16)',

            border:
              '1px solid rgba(255, 193, 7, 0.25)',
          }}
        >
          <BusinessRoundedIcon
            sx={{
              fontSize: 30,
              color: 'warning.main',
            }}
          />
        </Box>

        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              mb: 0.5,
            }}
          >
            Complete your organization setup
          </Typography>

          <Typography
            sx={{
              opacity: 0.78,
              lineHeight: 1.6,
              maxWidth: '720px',
            }}
          >
            {organization?.name
              ? `${organization.name} still needs a few details before setup is complete.`
              : 'Your organization still needs a few details before setup is complete.'}
            {' '}
            Confirm your organization information before you begin
            adding ATGs and managing users.
          </Typography>
        </Box>
      </Box>

      <Button
        variant="contained"
        color="secondary"
        endIcon={
          <ArrowForwardRoundedIcon />
        }
        onClick={onOpen}
        sx={{
          flexShrink: 0,

          width: {
            xs: '100%',
            md: 'auto',
          },

          minWidth: '190px',

          py: 1.25,
          px: 2.5,

          borderRadius: '10px',

          fontWeight: 800,

          whiteSpace: 'nowrap',
        }}
      >
        Complete Setup
      </Button>
    </Paper>
  );
};


export default OrganizationSetupWidget;